import { clsx } from 'clsx';
import Icon from './Icon';
import { useThemeContext } from '@/contexts/ThemeContext';
import { t } from '@/i18n/t';

interface ThemeToggleProps {
  className?: string;
}

/** The light / dark switch. Round 145: its label is translated (the admin site reads the English catalogue); the icon shows the CURRENT theme. */
export default function ThemeToggle({ className }: ThemeToggleProps) {
  const { theme, toggleTheme } = useThemeContext();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={theme === 'light' ? t('common:theme.switchToDark') : t('common:theme.switchToLight')}
      data-testid="theme-toggle"
      className={clsx(
        'inline-flex items-center justify-center rounded-lg min-h-touch min-w-touch',
        'text-muted hover:bg-paper-2 hover:text-ink transition-colors',
        className,
      )}
    >
      <Icon name={theme === 'light' ? 'sun' : 'moon'} size="md" />
    </button>
  );
}
